<script setup lang="ts">
import CategoriesPageWithButtons from "@/v2/layouts/categories/shared/CategoriesPageWithButtons.vue";
import { useMeta } from "vue-meta";
import useCategoriesController from "@/views/categories/useCategoriesController.ts";
import useCategoriesStructuredData from "@/views/categories/useCategoriesStructuredData.ts";

const {
  isTouchScreen,
  layoutController,
  onAccessibilityButtonClick,
  onBackButtonClick,
  onSearchSelected,
  onSearchQueryChanged,
  isSearchLoading,
  onSideMenuSelected,
  onPageUnmounted,
  searchOptions,
  searchQuery,
  popularSearchOptions,
  showQrButton,
  sideMenuItems,
  sideMenuSelected,
  sideMenuOpenOnInit,
  showSideMenu,
  sponsorMedia,
  showSearchButton,
  getVisitedItems,
  onPageIdle,
} = useCategoriesController();

const { generateScript } = useCategoriesStructuredData();

useMeta({
  script: generateScript().map((schemaObj) => ({
    type: "application/ld+json",
    json: schemaObj,
  })),
});
</script>

<template>
  <CategoriesPageWithButtons
    v-model:search-query="searchQuery"
    class="categories-container"
    data-testid="categories-container"
    :is-touch-screen
    :search-options
    :popular-search-options
    :is-search-loading
    :show-qr-button
    :side-menu-items
    :side-menu-selected
    :sponsor-media
    :side-menu-open-on-init
    :show-side-menu
    :show-search-button
    :visited-search-items="getVisitedItems"
    @on-accessibility-button-click="onAccessibilityButtonClick"
    @on-back-button-click="onBackButtonClick"
    @on-search-query-changed="onSearchQueryChanged"
    @on-search-selected="onSearchSelected"
    @on-side-menu-selected="onSideMenuSelected"
    @on-page-unmounted="onPageUnmounted"
    @on-page-idle="onPageIdle"
  >
    <component :is="layoutController" />
  </CategoriesPageWithButtons>
</template>
